import {
  useDispatch as originalUseDispatch,
  useSelector,
  TypedUseSelectorHook,
} from "react-redux";
import type { RootState, AppDispatch } from "./index";

export const useAppDispatch = () => originalUseDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
